export default class ChangePersonnelFailedError extends Error {
  name = 'ChangePersonnelFailedError';
}
